<template>
  <div>
    <br />
    <h1 class="text-xs-center">Advanced: Check Offline Buses</h1>
    <v-layout row wrap>
      <v-flex md4 xs12 pa-2>
        <v-btn color="primary" :disabled="apiInProgress || (currentConfig && !isCurrentConfigEdited)" @click="createConfig()">
          <v-icon>fal fa-plus</v-icon> &nbsp; New Config
        </v-btn>
        <div :style="$vuetify.breakpoint.smAndDown ? 'max-height: 200px; overflow-y: auto' : ''">
          <v-list two-line>
            <template v-for="(config, index) in configs">
              <v-list-tile :key="config.id" ripple @click="editConfig(config.id)">
                <v-list-tile-content>
                  <v-list-tile-title>{{ getAgencyLabel(config.agencyId) }}</v-list-tile-title>
                  <v-list-tile-sub-title class="text--primary">{{ config.formattedDateUpdated }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn
                    icon
                    :disabled="apiInProgress || config.agencyId === defaultProtectedAgencyId || (currentConfig && currentConfig.id === config.id)"
                    :title="config.agencyId === defaultProtectedAgencyId ? 'Cannot delete default agency config' : 'Delete config'"
                    @click.stop="deleteConfig(config)"
                  >
                    <v-icon small>fa fa-trash-alt</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider v-if="index + 1 < configs.length" :key="index" />
            </template>
          </v-list>
        </div>
        <div v-show="!configs.length" class="text-xs-center">
          <p>No available configs</p>
        </div>
      </v-flex>

      <v-flex md8 xs12 pa-2>
        <div class="d-flex row justify-space-between mb-3">
          <v-btn color="primary" :disabled="apiInProgress || !isCurrentConfigEdited || !currentConfig" @click="saveConfig()">Save</v-btn>
          <v-btn color="warning" :disabled="apiInProgress || !currentConfig" @click="cancelConfigEdit()">Cancel</v-btn>
        </div>

        <div v-show="!currentConfig" class="text-xs-center">
          Select a config from the list or create a new config
        </div>

        <div v-if="currentConfig">
          <v-layout row wrap>
            <v-flex xs12 md6 pa-1>
              <v-switch v-model="currentConfig.enabled" label="Enabled" />
            </v-flex>
            <v-flex xs12 md6 pa-1>
              <v-combobox
                v-model="currentConfig.agencyId"
                :items="agencyOptions"
                label="Agency ID"
                clearable
                :disabled="Boolean(currentConfig.id)"
              />
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 md6 pa-1>
              <v-text-field
                v-model.number="currentConfig.offlineThresholdMinutes"
                label="Offline threshold (minutes)"
                type="number"
                min="1"
              />
            </v-flex>
            <v-flex xs12 md6 pa-1>
              <v-text-field
                v-model.number="currentConfig.notificationIntervalMinutes"
                label="Notification interval (minutes)"
                type="number"
                min="1"
              />
            </v-flex>
            <v-flex xs12 md6 pa-1>
              <v-text-field
                v-model.number="currentConfig.consecutiveMapApiFailures"
                label="Consecutive map-api failures before notification"
                type="number"
                min="0"
              />
            </v-flex>
          </v-layout>

          <div class="d-flex justify-space-between align-center mb-2 mt-3">
            <h3 class="mb-0">Contacts</h3>
            <v-btn small :disabled="apiInProgress" @click="addContact()">
              <v-icon small left>fal fa-plus</v-icon>Add Contact
            </v-btn>
          </div>

          <div v-if="!currentConfig.contacts.length" class="text-xs-center">
            <p>No contacts added</p>
          </div>

          <v-card v-for="(contact, index) in currentConfig.contacts" :key="`contact-${index}`" class="mb-2">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md3 pa-1>
                  <v-select
                    v-model="contact.type"
                    :items="contactTypes"
                    label="Type"
                  />
                </v-flex>
                <v-flex xs12 md3 pa-1>
                  <v-text-field v-model="contact.name" label="Name" />
                </v-flex>
                <v-flex xs12 md5 pa-1>
                  <phone-number-field
                    v-if="contact.type === 'phone'"
                    v-model="contact.value"
                    :child-props="{ label: 'Phone' }"
                  />
                  <v-text-field
                    v-else
                    v-model="contact.value"
                    label="Email"
                    type="email"
                  />
                </v-flex>
                <v-flex xs12 md1 pa-1 class="text-xs-right">
                  <v-btn icon :disabled="apiInProgress" @click="removeContact(index)">
                    <v-icon small>fal fa-times</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import src from './src'
export default src
</script>
